import React, {StrictMode, useEffect, useState, useMemo} from 'react'
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux'
import MainSearchBox from './MainSearchBox'
import store from 'js/store';
import * as constants from './constants'
import {createPortal} from 'react-dom';
import {mainBp} from 'js/constants';
import configuration from './configuration'

/**
 * Search box with filters used for AB test on home page
 * If  Cookie present filters are enabled
 * and video banner for desktop applied html/src/js/components/homePageBanner
 * Created on base of search component styles
 *
 * @param searchBoxData<Object> - window.drupalSettings.widgets.searchBox
 * @param filtersData<Object>   - window.drupalSettings.widgets.filters
 * @param filtersTypes<Array>   - possible values ['dates', 'rooms', 'more', 'code']
 * @param activeFilter<String>  - defines the opened by default filter if is set.
 *                                Possible: 'dates', rooms', 'more'
 * @param pageIndex<Number>     - The index of current HTML page
 * @param containerId<String>   - id of root DOM element for search app.
 * @param sticky<Boolean>       - should search bar be sticky on page scroll
 *
 * @returns {*}
 */

const DEFAULT_CONTAINER_ID = 'search-box';

// Render new searchbar for mobile screen only.
// Desktop version would be also replaced in the near future
const SearchBoxSwitcher = function (props) {
  const mobileQuery = useMemo(
    () => window.matchMedia(`(max-width: ${mainBp - 1}px)`),
    [],
  )
  const [isMobile, setIsMobile] = useState(() => mobileQuery.matches)

  const configs = useMemo(function () {
    return isMobile ? {...props, ...(props?.response?.mobile || {})} : props
  }, [isMobile, props])

  useEffect(() => {
    const onChange = (event) => setIsMobile(event.matches)
    mobileQuery.addEventListener('change', onChange)
    return () => mobileQuery.removeEventListener('change', onChange)
  }, [mobileQuery]);

  if (configs.containerId) {
    document.getElementById(configs.containerId).classList.add('loaded');
  }

  return configs.containerId === props.containerId
    ? (<MainSearchBox {...configs} isMobile={isMobile} />)
    : (createPortal(<MainSearchBox {...configs} isMobile={isMobile} />, document.getElementById(configs.containerId)))
}

const initSearchBox = (props) => {
  const {
    containerId = DEFAULT_CONTAINER_ID,
  } = props;
  const configs = configuration[props.type] || configuration.default;
  const wrapEl = document.getElementById(configs.containerId || containerId);
  const isSearchBoxInHeader = wrapEl.closest('header') !== null;

  const root = createRoot(wrapEl);
  root.render(
    <StrictMode>
      <Provider store={store}>
        <SearchBoxSwitcher
          {...configs}
          {...props}
          isSearchBoxInHeader={isSearchBoxInHeader}
        />
      </Provider>
    </StrictMode>
  );
}


export {
  constants,
}
export default initSearchBox
